import { STATUS } from '@front-app/constants/state';

export class UrlInfo {
	status = STATUS.LOADING;

	isSuccess = false;

	originalUrl = '';

	requestedUrl = '';

	pageTitle = '';

	pageDescription = '';
}
